import { useLocation } from 'react-router-dom';
import React from 'react';
import { Location } from 'history';
import { usePreviousLocation } from './usePreviousLocation';
import { Breadcrumb } from './Breadcrumb';

export function LocationSpan() {
  const prev = formatLocation(usePreviousLocation());
  const curr = formatLocation(useLocation());
  return (
    <Breadcrumb
      name="navigation"
      tags={{
        'nvgtn.from_uri': prev,
        'nvgtn.to_uri': curr,
      }}
    />
  );
}

function formatLocation(loc: Location | null) {
  if (!loc) return '';
  return `${loc.pathname}${loc.search}${loc.hash}`;
}
